import React, { Component, ErrorInfo, ReactNode } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

interface AppInsightsErrorBoundaryProps {
  appInsights: ApplicationInsights;
  children: ReactNode;
}

interface AppInsightsErrorBoundaryState {
  hasError: boolean;
}

class AppInsightsErrorBoundary extends Component<
  AppInsightsErrorBoundaryProps,
  AppInsightsErrorBoundaryState
> {
  public state: AppInsightsErrorBoundaryState = {
    hasError: false,
  };

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ hasError: true });
    
    this.props.appInsights.trackException({
      exception: error,
      properties: {
        componentStack: errorInfo.componentStack,        
        errorMessage: error.message,
        errorName: error.name,
      },
    });
  }

  public render() {
    if (this.state.hasError) {      
      return (
        <div style={{ padding: '20px', border: '1px solid red', color: 'red' }}>
          <h2>Oops! Something went wrong.</h2>
          <p>We're working to fix it. Please try refreshing the page.</p>
        </div>
      );
    }

    return this.props.children || null;
  }
}

export default AppInsightsErrorBoundary;
export {}